<div class="content-wrapper p-40px">
  <button [routerLink]="'/concealed-damage'" class="btn-back" type="button">
    <i class="fa-light fa-arrow-left icon-21px"></i>
  </button>
  <div class="page-title-box">
    <h4>RA Request Detail</h4>
  </div>
  <perfect-scrollbar>
    <form [formGroup]="detailForm"
          [ngClass]="{'mr-34px': isMobile, 'mr-24px': !isMobile, 'form-submitted': isSubmitted}"
          class="p-12px">
      <div class="row">
        <div class="col-md-6">
          <div class="d-flex flex-row">
            <div class="col-4 item-label">Ticket#</div>
            <div class="col-8 item-row-value">{{ detailInfo?.ticketNo }}</div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="d-flex flex-row">
            <div class="col-4 item-label">Status</div>
            <div class="col-8 item-row-value">{{ detailInfo?.statusName }}</div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="d-flex flex-row">
            <div class="col-4 item-label">RA Request#</div>
            <div class="col-8 item-row-value">{{ detailInfo?.raRequestNo }}</div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="d-flex flex-row">
            <div class="col-4 item-label">RA #</div>
            <div class="col-8 item-row-value">{{ detailInfo?.raNo ? detailInfo?.raNo : 'N/A' }}</div>
          </div>
        </div>

        <ng-container *ngIf="!isNew">
          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">Requested At</div>
              <div
                class="col-8 item-row-value">{{ detailInfo?.auth?.createdAt | date: 'M/d/yyyy hh:mm a' | lowercase }}
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">Requested By</div>
              <div class="col-8 item-row-value">{{ detailInfo?.auth?.createdBy?.username }}</div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">Updated At</div>
              <div
                class="col-8 item-row-value">{{ detailInfo?.auth?.updatedAt | date: 'M/d/yyyy hh:mm a' | lowercase }}
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">Updated By</div>
              <div class="col-8 item-row-value">{{ detailInfo?.auth?.updatedBy?.username }}</div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">Approved At</div>
              <div class="col-8 item-row-value">{{ detailInfo?.approvedAt | date: 'M/d/yyyy hh:mm a' | lowercase }}
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">Approved By</div>
              <div class="col-8 item-row-value">{{ detailInfo?.approvedBy?.username }}</div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">RA Approved At</div>
              <div class="col-8 item-value">{{ detailInfo?.raApprovedAt | date: 'M/d/yyyy hh:mm a' | lowercase }}</div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">RA Approved By</div>
              <div class="col-8 item-row-value">{{ detailInfo?.raApprovedBy?.username }}</div>
            </div>
          </div>
        </ng-container>

        <div class="horizontal-line"></div>
        <ng-container *ngIf="roles.ussi.includes(userType) || (!isNew && (creatorType !== creatorTypes.cd))">
          <div class="l2-title">Customer Information</div>

          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">Customer</div>
              <div class="col-8 item-value">
                <ng-select (change)="changeCustomer($event)"
                           [items]="customerOptions"
                           [readonly]="!isEditable"
                           bindLabel="name"
                           bindValue="code"
                           class="form-control"
                           formControlName="customer"
                           placeholder="Customer">
                </ng-select>

              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">Contact Email</div>
              <div class="col-8 item-value">
                <input class="form-control"
                       formControlName="contactEmail"
                       id="contactEmail-input"
                       placeholder="Contact Email"
                       readonly
                       type="email">
                <dp-field-error [formField]="form['contactEmail']"></dp-field-error>
              </div>
            </div>
          </div>
          <div class="horizontal-line"></div>
        </ng-container>

        <ng-container
          *ngIf="(isNew && !roles.ussi.includes(userType)) || (!isNew && (creatorType === creatorTypes.cd))">
          <div class="l2-title">Contact for Damage Unit Location</div>

          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">First Name</div>
              <div class="col-8 item-value">
                <input [readonly]="!isEditable"
                       class="form-control"
                       formControlName="firstName"
                       id="firstName-input"
                       placeholder="First Name"
                       type="text">
                <dp-field-error [formField]="form['firstName']"></dp-field-error>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">Last Name</div>
              <div class="col-8 item-value">
                <input [readonly]="!isEditable"
                       class="form-control"
                       formControlName="lastName"
                       id="lastName-input"
                       placeholder="Last Name"
                       type="text">
                <dp-field-error [formField]="form['lastName']"></dp-field-error>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">Email</div>
              <div class="col-8 item-value">
                <input [readonly]="!isEditable"
                       class="form-control"
                       formControlName="email"
                       id="email-input"
                       placeholder="Email"
                       type="email">
                <dp-field-error [formField]="form['email']"></dp-field-error>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">Phone</div>
              <div class="col-8 item-value">
                <input [readonly]="!isEditable"
                       class="form-control"
                       formControlName="cellPhone"
                       id="phone-input"
                       placeholder="Phone"
                       type="tel">
                <dp-field-error [formField]="form['cellPhone']"></dp-field-error>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">Address</div>
              <div class="col-8 item-value">
                <app-google-places-autocomplete [data]="addressData" [disabled]="detailForm?.disabled || !isEditable"
                                                class="w-100 mw-100"></app-google-places-autocomplete>
              </div>
            </div>
          </div>

          <div class="horizontal-line"></div>
        </ng-container>


        <div class="d-flex justify-content-center w-100" style="min-width: 315px">
          <div id="reader"></div>
        </div>
        <div class="l2-title">Product Information</div>
        <div class="col-md-6">
          <div class="d-flex flex-row">
            <div class="col-4 item-label">Serial#</div>
            <div class="col-8 item-value">
              <input (change)="unverify($event)"
                     [readOnly]="(!isSerialEditable && isCdStoreReadOnly) || !isEditable"
                     autocomplete="off"
                     class="form-control"
                     formControlName="serialNo"
                     id="serial-input"
                     placeholder="Verify/scan serial # on product"
                     type="text">
              <dp-field-error [formField]="form['serialNo']"></dp-field-error>
            </div>
          </div>
        </div>
        <div *ngIf="isSerialEditable" class="col-md-6 d-flex align-items-center">
          <div class="d-flex flex-row h-100">
            <div class="col-6 py-8px">
              <button (click)="loadingScanner($event)"
                      *ngIf="!isAdminViewerRole"
                      [disabled]="isCdStoreReadOnly"
                      class="btn btn-dark btn-152px"
              >Scan
              </button>
            </div>
            <div class="col-6 p-8px">
              <button (click)="serialVerify($event)"
                      *ngIf="!isAdminViewerRole"
                      [disabled]="(!form.serialNo.value && !isVerify) || isCdStoreReadOnly"
                      class="btn btn-dark btn-152px">Verify
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="d-flex flex-row">
            <div class="col-4 item-label">Model#</div>
            <div class="col-8 item-value">
              <input [readOnly]="(!isSerialEditable && isCdStoreReadOnly) || !isEditable"
                     autocomplete="off"
                     class="form-control"
                     formControlName="modelCode"
                     id="model-input"
                     placeholder="Model Code"
                     type="text">
              <dp-field-error [formField]="form['modelCode']"></dp-field-error>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="d-flex flex-row">
            <div class="col-4 item-label">Report Type</div>
            <div class="col-8 item-value">
              <ng-select (change)="setOptionsByReportType($event)"
                         [items]="reportTypeOptions"
                         [readonly]="isCdStoreReadOnly || !isEditable"
                         bindLabel="name"
                         bindValue="code"
                         class="form-control"
                         formControlName="reportType"
                         placeholder="Report Type">
              </ng-select>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="d-flex flex-row">
            <div class="col-4 item-label">Product Type</div>
            <div class="col-8 item-value">
              <ng-select (change)="setOptionsByProductType($event)"
                         [items]="productTypeOptions"
                         [readonly]="isCdStoreReadOnly || !isEditable"
                         bindLabel="name"
                         bindValue="name"
                         class="form-control"
                         formControlName="productType"
                         placeholder="Please select a Product Type">
              </ng-select>
            </div>
          </div>
        </div>
        <div class="horizontal-line"></div>

        <ng-container *ngIf="hasCdAgentRole">
          <div class="d-flex flex-row">
            <div class="l2-title mt-minus">Billing Information</div>
            <div class="h-line">
              <img (click)="toggleBillingData()"
                   alt=""
                   class="btn-cursor condition-fold-expand"
                   src="assets/img/btn-condition-{{showBillingData ? 'expand' : 'fold'}}.svg">
            </div>
          </div>

          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">Sales Order #</div>
              <div class="col-8 item-value">
                <input class="form-control"
                       formControlName="salesOrderNo"
                       id="salesOrderNo-input"
                       placeholder="Sales Order #"
                       type="text">
                <dp-field-error [formField]="form['salesOrderNo']"></dp-field-error>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">Sales Org.</div>
              <div class="col-8 item-value">
                <input class="form-control"
                       formControlName="salesOrg"
                       id="salesOrg-input"
                       type="text">
                <dp-field-error [formField]="form['salesOrg']"></dp-field-error>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">Account no.(Sold-to)</div>
              <div class="col-8 item-value">
                <input class="form-control"
                       formControlName="soldToPartyCode"
                       id="soldToParty-input"
                       type="text">
                <dp-field-error [formField]="form['soldToParty']"></dp-field-error>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">Sold-To Party Name</div>
              <div class="col-8 item-value">
                <input class="form-control"
                       formControlName="soldToPartyName"
                       id="soldToPartyName-input"
                       type="text">
                <dp-field-error [formField]="form['soldToPartyName']"></dp-field-error>
              </div>
            </div>
          </div>
          <ng-container *ngIf="showBillingData">
            <div class="col-md-6">
              <div class="d-flex flex-row">
                <div class="col-4 item-label">Billing Party(Payer)</div>
                <div class="col-8 item-value">
                  <input class="form-control"
                         formControlName="payerPartyCode"
                         id="payerPartyCode-input"
                         type="text">
                  <dp-field-error [formField]="form['payerPartyCode']"></dp-field-error>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex flex-row">
                <div class="col-4 item-label">Bill-to</div>
                <div class="col-8 item-value">
                  <input class="form-control"
                         formControlName="billToPartyCode"
                         id="billToPartyCode-input"
                         type="text">
                  <dp-field-error [formField]="form['billToPartyCode']"></dp-field-error>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex flex-row">
                <div class="col-4 item-label">Purchase Date</div>
                <div class="col-8 item-value">
                  <input class="form-control"
                         formControlName="purchaseDate"
                         id="purchaseDate-input"
                         placeholder="Purchase Date"
                         type="text">
                  <dp-field-error [formField]="form['purchaseDate']"></dp-field-error>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex flex-row">
                <div class="col-4 item-label">Material No.</div>
                <div class="col-8 item-value">
                  <input class="form-control"
                         formControlName="materialNo"
                         id="materialNo-input"
                         type="text">
                  <dp-field-error [formField]="form['materialNo']"></dp-field-error>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex flex-row">
                <div class="col-4 item-label">Billing Date</div>
                <div class="col-8 item-value">
                  <input class="form-control"
                         formControlName="billingDate"
                         id="billingDate-input"
                         placeholder="Billing Date"
                         type="text">
                  <dp-field-error [formField]="form['billingDate']"></dp-field-error>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex flex-row">
                <div class="col-4 item-label">Billing Type</div>
                <div class="col-8 item-value">
                  <input class="form-control"
                         formControlName="billingType"
                         id="billingType-input"
                         type="text">
                  <dp-field-error [formField]="form['billingType']"></dp-field-error>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex flex-row">
                <div class="col-4 item-label">Distribution Channel</div>
                <div class="col-8 item-value">
                  <input class="form-control"
                         formControlName="distributionChannel"
                         id="distributionChannel-input"
                         type="text">
                  <dp-field-error [formField]="form['distributionChannel']"></dp-field-error>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex flex-row">
                <div class="col-4 item-label">Distribution Channel Name</div>
                <div class="col-8 item-value">
                  <input class="form-control"
                         formControlName="distributionChannelName"
                         id="distributionChannelName-input"
                         type="text">
                  <dp-field-error [formField]="form['distributionChannelName']"></dp-field-error>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex flex-row">
                <div class="col-4 item-label">Division</div>
                <div class="col-8 item-value">
                  <input class="form-control"
                         formControlName="division"
                         id="division-input"
                         type="text">
                  <dp-field-error [formField]="form['division']"></dp-field-error>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex flex-row">
                <div class="col-4 item-label">Division Name</div>
                <div class="col-8 item-value">
                  <input class="form-control"
                         formControlName="divisionName"
                         id="divisionName-input"
                         type="text">
                  <dp-field-error [formField]="form['divisionName']"></dp-field-error>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex flex-row">
                <div class="col-4 item-label">Unit Price</div>
                <div class="col-8 item-value">
                  <input class="form-control"
                         formControlName="unitPrice"
                         id="unitPrice-input"
                         type="text">
                  <dp-field-error [formField]="form['unitPrice']"></dp-field-error>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex flex-row">
                <div class="col-4 item-label">Moving Average Price</div>
                <div class="col-8 item-value">
                  <input class="form-control"
                         formControlName="movingAveragePrice"
                         id="movingAveragePrice-input"
                         type="text">
                  <dp-field-error [formField]="form['movingAveragePrice']"></dp-field-error>
                </div>
              </div>
            </div>

            <div class="mt-24px"></div>
            <div class="col-md-6">
              <div class="d-flex flex-row">
                <div class="col-4 item-label">Collection Pt.(Ship-to)</div>
                <div class="col-8 item-value">
                  <input class="form-control"
                         formControlName="shipToPartyCode"
                         id="shipToParty-input"
                         type="text">
                  <dp-field-error [formField]="form['shipToParty']"></dp-field-error>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex flex-row">
                <div class="col-4 item-label">Ship-To Party Name</div>
                <div class="col-8 item-value">
                  <input class="form-control"
                         formControlName="shipToPartyName"
                         id="shipToPartyName-input"
                         type="text">
                  <dp-field-error [formField]="form['shipToPartyName']"></dp-field-error>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex flex-row">
                <div class="col-4 item-label">Street</div>
                <div class="col-8 item-value">
                  <input class="form-control"
                         formControlName="shipToStreet"
                         id="shipToStreet-input"
                         type="text">
                  <dp-field-error [formField]="form['shipToStreet']"></dp-field-error>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex flex-row">
                <div class="col-4 item-label">District</div>
                <div class="col-8 item-value">
                  <input class="form-control"
                         formControlName="shipToDistrict"
                         id="shipToDistrict-input"
                         type="text">
                  <dp-field-error [formField]="form['shipToDistrict']"></dp-field-error>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex flex-row">
                <div class="col-4 item-label">Postal Code</div>
                <div class="col-8 item-value">
                  <input class="form-control"
                         formControlName="shipToPostalCode"
                         id="shipToPostalCode-input"
                         type="text">
                  <dp-field-error [formField]="form['shipToPostalCode']"></dp-field-error>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex flex-row">
                <div class="col-4 item-label">City</div>
                <div class="col-8 item-value">
                  <input class="form-control"
                         formControlName="shipToCity"
                         id="shipToCity-input"
                         type="text">
                  <dp-field-error [formField]="form['shipToCity']"></dp-field-error>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex flex-row">
                <div class="col-4 item-label">Country</div>
                <div class="col-8 item-value">
                  <input class="form-control"
                         formControlName="shipToCountry"
                         id="shipToCountry-input"
                         type="text">
                  <dp-field-error [formField]="form['country']"></dp-field-error>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex flex-row">
                <div class="col-4 item-label">Region</div>
                <div class="col-8 item-value">
                  <input class="form-control"
                         formControlName="shipToRegion"
                         id="shipToRegion-input"
                         type="text">
                  <dp-field-error [formField]="form['shipToRegion']"></dp-field-error>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex flex-row">
                <div class="col-4 item-label">Tel</div>
                <div class="col-8 item-value">
                  <input class="form-control"
                         formControlName="shipToTel"
                         id="shipToTel-input"
                         type="text">
                  <dp-field-error [formField]="form['shipToTel']"></dp-field-error>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex flex-row">
                <div class="col-4 item-label">Email</div>
                <div class="col-8 item-value">
                  <input class="form-control"
                         formControlName="shipToEmail"
                         id="shipToEmail-input"
                         type="text">
                  <dp-field-error [formField]="form['shipToEmail']"></dp-field-error>
                </div>
              </div>
            </div>
          </ng-container>
          <div class="horizontal-line"></div>
          <div class="l2-title">Info</div>
          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">PO No.</div>
              <div class="col-8 item-value">
                <input class="form-control"
                       formControlName="poNo"
                       id="poNo-input"
                       type="text">
                <dp-field-error [formField]="form['poNo']"></dp-field-error>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">Req. Delivery Date</div>
              <div class="col-8 item-value">
                <input class="form-control"
                       formControlName="reqDeliDate"
                       id="reqDeliDate-input"
                       type="text">
                <dp-field-error [formField]="form['reqDeliDate']"></dp-field-error>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">PO Date</div>
              <div class="col-8 item-value">
                <input class="form-control"
                       formControlName="poDate"
                       id="poDate-input"
                       type="text">
                <dp-field-error [formField]="form['poDate']"></dp-field-error>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">Remark (Header Text)</div>
              <div class="col-8 item-value">
                <input class="form-control"
                       formControlName="remark"
                       id="remark-input"
                       type="text">
                <dp-field-error [formField]="form['remark']"></dp-field-error>
              </div>
            </div>
          </div>
          <div class="horizontal-line"></div>
        </ng-container>
        <div class="d-flex flex-row justify-content-between pl-0">
          <div class="l2-title">Photos</div>
          <div class="d-flex flex-row justify-content-end pl-0">
            <div *ngIf="!isAdminViewerRole">
              <button (click)="addPhoto($event)"
                      *ngIf="isNew || ( roles.cdCreator.includes(userType) && ['DRAFT', 'REJECT', 'DATA'].includes(detailInfo?.status)) || !roles.cdCreator.includes(userType)"
                      [disabled]="photos.length > 15 || ['PROCESS','APPROVE', 'RA-REJECT', 'COMPLETE'].includes(detailInfo?.status) || isCdStoreReadOnly"
                      class="btn btn-dark">Add
              </button>
            </div>
            <div *ngIf="hasCdAgentRole" class="ml-8px">
              <button (click)="fileDownload(detailInfo?.ticketNo, 'photo')" class="btn btn-dark">Download</button>
            </div>
          </div>
        </div>
        <div *ngFor="let photo of photos; let i = index;" class="col-md-6">
          <div class="d-flex flex-row">
            <div class="col-4 item-label">{{ photo.fieldname }}</div>
            <div class="col-8 item-value-photo">
              <div class="file-select-container">
                <ng-container *ngIf="isNew">
                  <app-dp-form-data-file-select (fileDelete)="fileDelete($event, photo.fieldname)"
                                                (outFile)="fileSelected($event, photo.fieldname)"
                                                [initInfo]="initInfo">
                  </app-dp-form-data-file-select>
                </ng-container>
                <ng-container *ngIf="!isNew">
                  <app-dp-img-select (fileDelete)="deleteImg(photo.fieldname)"
                                     (outFile)="selectImg($event, photo.fieldname)"
                                     (showFile)="openPhotoDetail($event, photo.fieldname)"
                                     [deletable]="isPhotoDeletable()"
                                     [initInfo]="initInfo"
                                     [photoInfo]="photo">
                  </app-dp-img-select>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <div class="horizontal-line"></div>
        <ng-container *ngIf="roles.agent.includes(userType) || roles.admin.includes(userType)">
          <div class="l2-title">Return Reason & Sub Return Reason</div>
          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">Return Reason</div>
              <div class="col-8 item-value flex-row">
                <ng-select (change)="changeReason($event)"
                           [items]="returnReasonOptions"
                           [readonly]="isCdStoreReadOnly || !isEditable"
                           bindLabel="name"
                           bindValue="code"
                           class="form-control"
                           formControlName="returnReason"
                           placeholder="Return Reason">
                </ng-select>
                <font-awesome [cssClass]="'ml-8px mr-8px'" [icon]="'fa-regular fa-exclamation-circle'"
                              placement="left" tooltip="Exceptional Sales Return"></font-awesome>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">Sub Reason</div>
              <div class="col-8 item-value flex-row">
                <ng-select [items]="subReasonOptions"
                           [readonly]="isCdStoreReadOnly || !isEditable"
                           bindLabel="name"
                           bindValue="code"
                           class="form-control"
                           formControlName="subReason"
                           placeholder="Sub Reason">
                </ng-select>
                <font-awesome [cssClass]="'ml-8px mr-8px'" [icon]="'fa-regular fa-exclamation-circle'"
                              placement="left" tooltip="Exceeded Concealed Damage Standard"></font-awesome>
              </div>
            </div>
          </div>
          <div class="horizontal-line"></div>
        </ng-container>
        <div class="l2-title">Details</div>
        <ng-container *ngIf="roles.ussi.includes(userType) || (!isNew && (creatorType !== creatorTypes.cd))">
          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">Packaging</div>
              <div class="col-8 item-value">
                <ng-select [items]="packagingOptions"
                           [readonly]="isCdStoreReadOnly || !isEditable"
                           bindLabel="name"
                           bindValue="code"
                           class="form-control"
                           formControlName="packaging"
                           placeholder="Packaging">
                </ng-select>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">Appearance</div>
              <div class="col-8 item-value">
                <ng-select [items]="appearanceOptions"
                           [readonly]="isCdStoreReadOnly || !isEditable"
                           bindLabel="name"
                           bindValue="code"
                           class="form-control"
                           formControlName="appearance"
                           placeholder="Appearance">
                </ng-select>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">Accessory</div>
              <div class="col-8 item-value">
                <ng-select [items]="accessoryOptions"
                           [readonly]="isCdStoreReadOnly || !isEditable"
                           bindLabel="name"
                           bindValue="code"
                           class="form-control"
                           formControlName="accessory"
                           placeholder="Accessory">
                </ng-select>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">Function</div>
              <div class="col-8 item-value">
                <ng-select [items]="functionOptions"
                           [readonly]="isCdStoreReadOnly || !isEditable"
                           bindLabel="name"
                           bindValue="code"
                           class="form-control"
                           formControlName="func"
                           placeholder="Function">
                </ng-select>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container
          *ngIf="roles.ussi.includes(userType) || (!isNew && (creatorType !== creatorTypes.cd)) || roles.cdReviewer.includes(userType) || hasCdAgentRole">
          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">Defect Details</div>
              <div class="col-8 item-value">
                <ng-select [items]="defectDetails"
                           [readonly]="isCdStoreReadOnly || !isEditable"
                           bindLabel="name"
                           bindValue="code"
                           class="form-control"
                           formControlName="defectDetails"
                           placeholder="Defect Details">
                </ng-select>
                <dp-field-error [formField]="form['defectDetails']"></dp-field-error>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="!roles.cdCreator.includes(userType) || isCsdRejected">
          <div class="col-md-6">
            <div class="d-flex flex-row">
              <div class="col-4 item-label">Rejection Reason</div>
              <div class="col-8 item-value">
                <ng-select [items]="rejectReasons"
                           [readonly]="isCdStoreReadOnly || !isEditable"
                           bindLabel="name"
                           bindValue="code"
                           class="form-control"
                           formControlName="rejectionReason"
                           placeholder="Rejection Reason">
                </ng-select>
                <dp-field-error [formField]="form['rejectionReason']"></dp-field-error>
              </div>
            </div>
          </div>
        </ng-container>


        <div class="col-md-6">
          <div class="d-flex flex-row">
            <div class="col-4 item-label">Symptom</div>
            <div class="col-8 item-value">
              <textarea [readonly]="isCdStoreReadOnly || !isEditable"
                        class="text-area form-control"
                        formControlName="symptom"
                        id="symptom"
                        name="symptom"
                        rows="5">
              </textarea>
              <dp-field-error [formField]="form['symptom']"></dp-field-error>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="d-flex flex-row">
            <div class="col-4 item-label">Panel Usage in Hours
              <button (click)="modalOpen()" class="btn-question" type="button">
                <i class="fa-regular fa-circle-question i-question"></i>
              </button>
            </div>

            <div class="col-8 item-value">
              <input [readonly]="isCdStoreReadOnly || !isEditable"
                     class="form-control"
                     formControlName="panelUsageHours"
                     id="panel-usage-hours-input"
                     placeholder="Panel Usage Hours"
                     type="text">
              <dp-field-error [error]="'It\'s invalid value, only allowed number or \'N/A\''"
                              [formField]="form['panelUsageHours']"></dp-field-error>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="d-flex flex-row">
            <div class="col-4 item-label">Customer PO</div>
            <div class="col-8 item-value">
              <input [readonly]="isCdStoreReadOnly || !isEditable"
                     class="form-control"
                     formControlName="customerPo"
                     id="customerPo-input"
                     placeholder="Customer PO"
                     type="text">
              <dp-field-error [formField]="form['customerPo']"></dp-field-error>
            </div>
          </div>
        </div>

        <div class="horizontal-line"></div>

        <!-- CD Reviewer일 경우에만 approve 할 경우 최소 1개의 파일 있어야함      -->
        <!-- 2023-04-14 고객 요청으로 무조건 숨기기 위해 false 추가 -->
        <ng-container *ngIf="(roles.agent.includes(userType) || roles.admin.includes(userType)) && false">
          <div class="d-flex flex-row justify-content-between pl-0">
            <div class="l2-title">File Attachments</div>
            <div class="d-flex flex-row justify-content-end pl-0">
              <div>
                <button (click)="addFile($event)"
                        [disabled]="!['REVIEW', 'REJECT'].includes(detailInfo?.status) || files.length > 10"
                        class="btn btn-dark">Add
                </button>
              </div>
              <div *ngIf="detailInfo?.attachments.length > 0" class="ml-8px">
                <button (click)="fileDownload(detailInfo?.ticketNo, 'file')"
                        class="btn btn-dark">Download
                </button>
              </div>
            </div>
          </div>
          <div *ngFor="let file of files; let i = index;" class="col-3 item-value-photo">
            <div class="file-select-container wd-206px">
              <app-dp-file-select (fileDelete)="deleteAttachFile(file, i)"
                                  (outFile)="selectAttachFile($event, file)"
                                  [deletable]="isAttachFileDeletable()"
                                  [fileInfo]="file"
                                  [initInfo]="initInfo">
              </app-dp-file-select>
            </div>
          </div>
          <div class="horizontal-line"></div>
        </ng-container>
        <!-- CD Reviewer는 APPROVE된 건에 대해서 RA From을 업로드 가능함 -->
        <ng-container
          *ngIf="(roles.agent.includes(userType) || roles.admin.includes(userType)) && detailInfo?.status === 'APPROVE' ">
          <div class="d-flex flex-row justify-content-between pl-0">
            <div class="l2-title">RA Form</div>
          </div>
          <div [ngClass]="{'disable-admin-viewer': isAdminViewerRole}" class="col-3 item-value-photo">
            <div class="file-select-container wd-206px">
              <app-dp-file-select (fileDelete)="deleteRaFromFile(raForms[0], 0)"
                                  (outFile)="selectRaForm($event, raForms[0])"
                                  [deletable]="isRaFormDeletable()"
                                  [fileInfo]="raForms[0]"
                                  [initInfo]="initInfo">
              </app-dp-file-select>
            </div>
          </div>
          <div class="horizontal-line"></div>
        </ng-container>
        <ng-container *ngIf="detailInfo?.reviewResults && detailInfo?.reviewResults.length > 0">
          <div class="d-flex flex-row justify-content-between pl-0">
            <div class="l2-title">Review Results</div>
          </div>
          <div class="d-flex flex-row">
            <div class="detail-label col-1">No.</div>
            <div [ngClass]="{'detail-label': true, 'col-1': !isMobile, 'col-5': isMobile}">Review Result</div>
            <div [ngClass]="{'detail-label': true, 'col-1': !isMobile, 'col-6': isMobile}">Review Date</div>
            <div *ngIf="!isMobile" class="detail-label col-2">Reviewed By</div>
            <div *ngIf="!isMobile" class="detail-label col-3">Comment</div>
          </div>
          <div *ngFor="let reviewResult of detailInfo?.reviewResults; let i=index;" class="d-flex flex-row">
            <div class="detail-value col-1">{{ i + 1 }}</div>
            <div
              [ngClass]="{'detail-label': true, 'col-1': !isMobile, 'col-5': isMobile}">{{ reviewResult.reviewResult }}
            </div>
            <div
              [ngClass]="{'detail-label': true, 'col-1': !isMobile, 'col-6': isMobile}">{{ reviewResult.reviewedAt | hqDateOptionalTime }}
            </div>
            <div *ngIf="!isMobile" class="detail-value col-2">{{ reviewResult.reviewedBy }}</div>
            <div *ngIf="!isMobile" class="detail-value col-3">{{ reviewResult.comment }}</div>
          </div>
        </ng-container>

        <div class="d-flex px-0 pt-24px">
          <button [routerLink]="'/concealed-damage'" class="btn btn-outline-dark">Back</button>
          <button
            (click)="updateDetail($event, 'DELETE')"
            *ngIf="isDeletable && !isAdminViewerRole"
            class="btn btn-outline-dark ml-4px">Delete
          </button>
          <ng-container *ngIf="roles.cdCreator.includes(userType)">
            <button
              (click)="submitForm($event)"
              *ngIf="isNew || ['DRAFT', 'DATA'].includes(detailInfo?.status) && roles.cdCreator.includes(userType) && !isCdStoreReadOnly && !isAdminViewerRole"
              [disabled]="!isVerify"
              [ngClass]="{'btn': true, 'btn-dark': true, 'ms-auto': !isMobile, 'ml-4px': isMobile}"
              type="button">
              Save Draft
            </button>

            <!--  TODO comment 입력되었을때 status DATA 재요청 버튼 활성화 맞는지?         -->
            <button
              (click)="updateDetail($event, 'REVIEW')"
              *ngIf="isNew || ['DRAFT', 'DATA', 'REJECT'].includes(detailInfo?.status) && roles.cdCreator.includes(userType) && !isCdStoreReadOnly && !isAdminViewerRole"
              [disabled]="!isVerify"
              [ngClass]="{'btn': true, 'btn-dark': true, 'ms-auto': !isMobile, 'ml-4px': isMobile}">Request Review
            </button>
            <button
              (click)="updateDetail($event, 'DRAFT')"
              *ngIf="['REVIEW'].includes(detailInfo?.status) && roles.cdCreator.includes(userType) && !isCdStoreReadOnly && !hasRejectedHistory() && !isAdminViewerRole"
              class="btn btn-dark ms-auto">Revise
            </button>
          </ng-container>

          <button
            (click)="download(raForms[0])"
            *ngIf="['APPROVE', 'COMPLETE'].includes(detailInfo?.status) && raForms?.length > 0 && raForms[0].file !== null"
            class="btn btn-dark ms-auto">Print RA Form
          </button>

          <!--            <button *ngIf="['APPROVE'].includes(detailInfo?.status) && detailInfo?.raForms?.length > 0" (click)="updateDetail($event, 'COMPLETE')"-->
          <!--                    class="btn btn-dark ml-12px">Complete-->
          <!--            </button>-->


          <ng-container
            *ngIf="['REVIEW', 'REJECT'].includes(detailInfo?.status) && (roles.cdReviewer.includes(userType) || hasCdAgentRole) && !isAdminViewerRole">
            <button (click)="updateDetail($event, 'REJECT')" *ngIf="detailInfo?.status !== 'REJECT'"
                    class="btn btn-outline-dark ml-12px">Reject
            </button>
            <button (click)="updateDetail($event, 'SAVE')" class="btn btn-dark ms-auto">Save</button>
            <button (click)="updateDetail($event, 'PROCESS')" class="btn btn-dark ms-auto">Approve</button>
          </ng-container>
        </div>

        <!--   TODO remove     -->
        <!--<div class="d-flex px-0 pt-24px">
          <div class="ms-auto"> Print TEST
            <a [href]="download() | secure | async" target="_blank" role="button" class="btn btn-dark w-100">Download</a>
          </div>
        </div>-->

      </div> <!--row-->
    </form>
  </perfect-scrollbar>
</div>
